import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SEITENGROESSEN, letzteSeite } from '../katalogBlaetterung';

/**
 * Die Blaetterung unter der Tabelle (argus-platform #193).
 *
 * Bewusst nummeriert (`Pagination`) und nicht bloss vor/zurueck: fuer einen
 * Datenkatalog ist der Sprung auf eine Seite der Punkt -- man will sich auf "Seite
 * 12" beziehen koennen. Endloses Scrollen kann das nicht, deshalb schliesst das
 * Ticket es ausdruecklich aus.
 *
 * Die Bereichsangabe ("51-100 von 1977") steht daneben, weil die Zahl der Zeilen
 * allein nicht sagt, wo man ist -- und weil sie die Gegenprobe fuer den Nutzer ist:
 * kommt sie nicht mit der Tabelle zusammen, stimmt etwas nicht.
 */
const KatalogBlaetterung = ({ seite, seitengroesse, gesamtzahl, onSeite, onSeitengroesse }) => {
  const { t } = useTranslation();

  // Ohne Gesamtzahl (Fehlerfall) keine Blaetterung: eine Leiste, die "Seite 1 von 1"
  // behauptet, waehrend nichts geladen ist, ist eine Falschaussage.
  if (!Number.isFinite(gesamtzahl) || gesamtzahl <= 0) {
    return null;
  }

  const seiten = letzteSeite(gesamtzahl, seitengroesse);
  const von = (seite - 1) * seitengroesse + 1;
  const bis = Math.min(seite * seitengroesse, gesamtzahl);

  return (
    <Box
      sx={{
        mt: 2,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Typography variant="body2" color="textSecondary">
        {t('dataCatalog.pagination.range', { von, bis, gesamt: gesamtzahl })}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <FormControl size="small" sx={{ minWidth: 130 }}>
          <InputLabel id="katalog-seitengroesse">{t('dataCatalog.pagination.pageSize')}</InputLabel>
          <Select
            labelId="katalog-seitengroesse"
            label={t('dataCatalog.pagination.pageSize')}
            value={seitengroesse}
            onChange={(event) => onSeitengroesse(Number(event.target.value))}
          >
            {SEITENGROESSEN.map(groesse => (
              <MenuItem key={groesse} value={groesse}>{groesse}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <Pagination
          count={seiten}
          page={Math.min(seite, seiten)}
          onChange={(event, neueSeite) => onSeite(neueSeite)}
          color="primary"
          shape="rounded"
          showFirstButton
          showLastButton
          siblingCount={1}
          aria-label={t('dataCatalog.pagination.aria')}
        />
      </Box>
    </Box>
  );
};

export default KatalogBlaetterung;
